export enum BillingAdjustmentIssueType {
    EXPEDITE_FEE_WAIVED = 'Expedite Fee Waived',
    PRICE_OVERRIDE_DISCOUNTED_ORDERS = 'Price Override/Discounted Orders',
    POC_PRICE_PROMO = 'POC Price Promo'
}
